import { IHourMinuteSecond } from "@/interface";

export const convertSecondsToHoursMinutesSecond = (second: number): IHourMinuteSecond => {
    if (!second) {
        return { h: 0, m: 0, s: 0 };
    }

    const totalMinutes = Math.floor(second / 60);
    const seconds = second % 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return { h: hours, m: minutes, s: seconds };
}

export const convertSecondsToMinutes = (second: number): number => {
    if (!second) {
        return second;
    }
    return Math.floor(second / 60);
}

export const convertSecondsToStringHoursMinutesSecond = (second: number): string => {
    const hourMinuteSecond : IHourMinuteSecond = convertSecondsToHoursMinutesSecond(second);
    return `${hourMinuteSecond.h?.toString().padStart(2, '0')}:${hourMinuteSecond.m?.toString().padStart(2, '0')}:${hourMinuteSecond.s?.toString().padStart(2, '0')}`
}